'use client';
import React__default from 'react';
import { Button as Button$1 } from './Button.js';
import { Button as Button$2 } from './ButtonV2.js';

const ButtonHOC = Component => {
  const MigratedButton = _ref => {
    let {
      v2,
      ...props
    } = _ref;
    if (v2) {
      return /*#__PURE__*/React__default.createElement(Button$2, props);
    }
    return /*#__PURE__*/React__default.createElement(Component, props);
  };
  MigratedButton.displayName = `MigratedButton(${Component.displayName || Component.name})`;
  return MigratedButton;
};
const Button = ButtonHOC(Button$1);

export { Button, ButtonHOC };
